import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import findPrograms from "@/views/newPlatform/findPrograms.vue";
import favouritePrograms from "@/views/newPlatform/favouritePrograms.vue";
import indexPlatform from "@/views/newPlatform/index.vue";
import inProgram from "@/views/newPlatform/inProgram.vue";
import admission from "@/views/newPlatform/admission.vue";
import schools from "@/views/newPlatform/schools.vue";
import intGrants from "@/views/newPlatform/intGrants.vue";
import grantDetail from "@/views/newPlatform/grantDetail.vue";
import premium from "@/views/newPlatform/premium.vue";
import useful from "@/views/newPlatform/useful.vue";
import curatorIndex from "@/views/curator/index.vue";
import users from "@/views/curator/users.vue";
import loginPage from "../views/login/loginPage.vue";
import LandingPage from "../views/landing/LandingPage.vue";
import registrationPage from "../views/login/registrationPage.vue";
import programs from "@/views/curator/programs.vue";
import userView from "@/views/curator/userView.vue";
import notifications from '@/views/curator/notifications.vue';
import index from '@/views/supervisor/index.vue';
import curators from '@/views/supervisor/curators.vue';
import superUsers from '@/views/supervisor/users.vue';
import platform from '@/views/supervisor/platform.vue';
import superSchools from '@/views/supervisor/schools.vue';
import news from '@/views/supervisor/news.vue';
import premiumVisor from '@/views/supervisor/premium.vue';
import basket from '@/views/newPlatform/basket.vue';
import waitPrograms from '@/views/curator/waitPrograms.vue';
import requests from '@/views/curator/requests.vue';
import supervisorRequests from '@/views/supervisor/requests.vue';
import registerGuestPage from '@/views/login/registerGuestPage.vue';
import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'home',
    component: loginPage,
  },
  // Лендинг временно скрыт (нет готового контента для прода). Не удалять — вернуть component: LandingPage когда контент будет готов.
  // {
  //   path: '/landing',
  //   name: 'landing',
  //   component: LandingPage,
  // },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
  },
  {
    path: '/platform/basket',
    name: 'basket',
    component: basket,
    meta: {
      requiresAuth: true,
      roles: ['user', ]
    }
  },
  {
    path: "/registration",
    name: "registration",
    component: registrationPage,
  },
  {
    path: '/registration-guest',
    name: 'registration-guest',
    component: registerGuestPage,
  },
  {
    path: '/reset',
    name: 'reset-password',
    component: () => import('@/views/login/resetPass.vue'),
  },
  {
    path: "/supervisor",
    name: "supervisor",
    component: index,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/supervisor/news",
    name: "news",
    component: news,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/supervisor/premium",
    name: "premiumVisor",
    component: premiumVisor,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/supervisor/curators",
    name: "curators",
    component: curators,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/supervisor/users",
    name: "superUsers",
    component: superUsers,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/supervisor/schools",
    name: "superSchools",
    component: superSchools,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/supervisor/platform",
    name: "platform",
    component: platform,
    meta: {
      requiresAuth: true,
      roles: ['supervisor', 'chief']
    }
  },
  {
    path: "/curator",
    name: "curator",
    component: curatorIndex,
    meta: {
      requiresAuth: true,
      roles: ['curator', 'expert']
    }
  },
  {
    path: "/curator/notifications",
    name: "notifications",
    component: notifications,
    meta: {
      requiresAuth: true,
      roles: ['curator', 'expert', 'supervisor', 'chief']
    }
  },
  // {
  //   path: "/curator/waitPrograms",
  //   name: "waitPrograms",
  //   component: waitPrograms,
  // },
  {
    path: "/curator/users",
    name: "users",
    component: users,
    meta: {
      requiresAuth: true,
      roles: ['curator', 'expert']
    }
  },
  {
    path: "/curator/programs",
    name: "curatorPrograms",
    component: programs,
    meta: {
      requiresAuth: true,
      roles: ['curator', 'expert']
    }
  },
  {
    path: '/expert/requests',
    name: 'requests',
    component: requests,
    meta: {
      requiresAuth: true,
      roles: ['expert']
    }
  },
  
  {
    path: '/chief/requests',
    name: 'chiefRequests',
    component: supervisorRequests,
    meta: {
      requiresAuth: true,
      roles: [   'chief']
    }
  },
  {
    path: "/curator/users/:id",
    name: "userView",
    component: userView,
    meta: {
      requiresAuth: true,
      roles: ['curator', 'expert', 'chief', 'supervisor']
    }
  },
  {
    path: "/platform",
    name: "test",
    component: indexPlatform,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'guest']
    }
  },
  {
    path: "/platform/admission",
    name: "admission",
    component: admission,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user']
    }
  },
  {
    path: "/platform/premium",
    name: "premium",
    component: premium,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'guest']
    }
  },
  {
    path: "/platform/intGrants",
    name: "intGrants",
    component: intGrants,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'guest']
    }
  },
  {
    path: "/platform/intGrants/:id",
    name: "grantDetail",
    component: grantDetail,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'guest']
    }
  },
  {
    path: "/platform/useful",
    name: "useful",
    component: useful,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'guest']
    }
  },
  {
    path: "/platform/schools",
    name: "schools",
    component:schools,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'guest']
    }
  },
  {
    path: "/favourites",
    name: "favourites",
    component: favouritePrograms,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user']
    }
  },
  {
    path: "/programs",
    name: "programs",
    component: findPrograms,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'chief', 'supervisor', 'curator', 'expert', 'guest']
    }
  },
  {
    path: "/programs/:id",
    name: "program",
    component: inProgram,
    meta: {
      isPlatform: true,
      requiresAuth: true,
      roles: ['user', 'chief', 'supervisor', 'curator', 'expert', 'guest']
    }
  },
]

const router = createRouter({ 
  history: createWebHistory(process.env.BASE_URL), 
  routes, 
  scrollBehavior(to) { 
    // Проверяем, есть ли у нас хэш-адрес в объекте to 
    if (to.hash) { 
       
        const el = document.querySelector(to.hash); 
        if (el) { 
        const scrollTop = el.getBoundingClientRect().top + window.pageYOffset - 85; 
        window.scrollTo({ 
            top: scrollTop, 
            behavior: 'smooth' 
        }); 
        return null; 
      } 
 
    } else { 
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' }) 
      // return { top: 0 } 
    } 
  } 
})
const roleHomeRoutes = {
  user: '/programs',
  curator: '/curator',
  expert: '/curator',
  chief: '/supervisor',
  supervisor: '/supervisor'
}
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const userRole = localStorage.getItem("user_role"); // например: "user", "curator", ...

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const allowedRoles = to.meta.roles;

  // Проверка авторизации
  if (requiresAuth && !isAuthenticated) {
    return next({ name: "login" });
  }

  // Проверка доступа по ролям
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    let redirectPath = roleHomeRoutes[userRole] || '/';
    if (userRole === 'user' && store.state.hasApprovedPrograms) {
      redirectPath = '/platform';
    }
    return next(redirectPath);
  }

  if (
    userRole === 'user' &&
    to.path === '/platform' &&
    store.state.hasApprovedPrograms === false
  ) {
    return next('/programs');
  }

  const isProgramFrom = /^\/programs(\/\d+)?$/.test(from.path);
  const isProgramTo = /^\/programs(\/\d+)?$/.test(to.path);

  // Если вы переходите с /program или /program/:id на другой раздел
  if (isProgramFrom && !isProgramTo) {
    localStorage.removeItem('search_find_model');
  }


  next(); // Всё ок
});
export default router;
